import * as Sentry from '@sentry/browser'
import DevLog from './DevLog'

// Centralized list of error patterns that should be ignored
// (commonly caused by ad blockers, privacy settings, or network issues)
export const IGNORED_ERROR_PATTERNS = {
  errorTypes: [
    'ScriptLoadError',
    'ScriptLoadTimeout',
    'ScriptMethodUnavailable',
    'ScriptInjectionError',
    'SecurityError',
    'AbortError'
  ],

  urlPatterns: [
    'google-analytics.com',
    'googletagmanager.com',
    'intercom.io',
    'recaptcha',
    'analytics.js',
    'translate.goog',
    'translate-pa.googleapis.com'
  ],

  messagePatterns: [
    'Load failed',
    'Failed to fetch',
    'script failed to load',
    'analytics',
    'recaptcha',
    'intercom',
    'aborted a request',
    'user aborted',
    'translate',
    'timeout',
    'network error',
    'net::',
    'ERR_NETWORK_CHANGED',
    'ERR_INTERNET_DISCONNECTED',
    'runtime.sendMessage',
    'invalid call to runtime.sendmessage'
  ]
}

// Centralized function to determine if an error should be ignored
export const shouldIgnoreError = (error) => {
  // Check error type
  if (IGNORED_ERROR_PATTERNS.errorTypes.includes(error.name)) {
    return true
  }

  // Check if error message contains blocked URLs
  if (error.scriptUrl && IGNORED_ERROR_PATTERNS.urlPatterns.some(url => error.scriptUrl.includes(url))) {
    return true
  }

  // Check error message for common patterns
  if (IGNORED_ERROR_PATTERNS.messagePatterns.some(pattern =>
    error.message.toLowerCase().includes(pattern))) {
    return true
  }

  return false
}

// Enhanced error handler that filters out common external script loading errors
const CatchError = (error, context = {}) => {
  // Check if this is a common external script loading error that shouldn't be reported
  if (shouldIgnoreError(error)) {
    DevLog(['Ignoring common external script error:', error.name])
    return
  }

  // Report unexpected errors to Sentry with context
  Sentry.captureException(error, {
    tags: {
      errorType: error.name || 'UnknownError',
      scriptUrl: error.scriptUrl || 'unknown',
      expectedMethod: error.expectedMethod || 'unknown'
    },
    extra: context
  })
}

export default CatchError
